"use client";

import {useEffect} from "react";
import {trackEvent} from "../lib/mixpanel-client";

interface MixpanelTrackEventProps {
	event: string;
	properties?: Record<string, unknown>;
}

/**
 * Component to track a Mixpanel event on mount.
 * Useful for page view tracking or other one-time events.
 *
 * @example
 * <MixpanelTrackEvent
 *   event="Contact Us Page Viewed"
 *   properties={{ page: "contact-us", path: "/" }}
 * />
 */
export default function MixpanelTrackEvent({
	event,
	properties,
}: MixpanelTrackEventProps) {
	useEffect(() => {
		void trackEvent(event, properties);
		// intentionally fire only once on mount
	}, []);

	return null;
}
